__turbopack_context__.v({
  "container": "DeliveryHistory-module__nWyT5a__container",
});
